import React from "react";
import { useIntl } from "react-intl";
import { ReactComponent as SearchIcon } from "./assets/search.svg";
import { Form } from "react-bootstrap";

const Filter = ({ filterText, onFilter }) => {
    const intl = useIntl();
    return (
        <div className="filter-wrp">
            <div className="form-group">
                <Form.Control
                    id="search"
                    type="text"
                    placeholder={intl.formatMessage({ id: "search" })}
                    value={filterText}
                    onChange={onFilter}
                />
                <SearchIcon />
            </div>
        </div>
    );
};

export default Filter;
